import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c1c09b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view join" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Join = _resolveComponent("Join")!
  const _component_JoinFailPopup = _resolveComponent("JoinFailPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Join),
    (_ctx.joinFailPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_JoinFailPopup, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}